import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiConsts } from 'src/app/utils/api.consts';
import { AuthCredentialsDto, AuthenticatedUser, MFAConfigurationDto, QRCodeSetup, Token } from 'src/app/models/auth.models';

export interface RedirectConfig {
  token?: string;
  invitationUuid: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthCloudService {
  private httpClient: HttpClient = inject(HttpClient);
  constructor() {}

  authenticateCredentials(credentials: AuthCredentialsDto): Observable<Token> {
    return this.httpClient.post<Token>(ApiConsts.AUTH.CREDENTIALS, credentials);
  }

  setupMfa(): Observable<QRCodeSetup> {
    return this.httpClient.get<QRCodeSetup>(ApiConsts.AUTH.SETUP_MFA).pipe();
  }

  configureMfa(mfaConfigurationCode: MFAConfigurationDto): Observable<void> {
    return this.httpClient.post<void>(ApiConsts.AUTH.CONFIGURE_MFA, mfaConfigurationCode);
  }

  authenticatedUser(): Observable<AuthenticatedUser> {
    return this.httpClient.get<AuthenticatedUser>(ApiConsts.AUTH.AUTHENTICATED_USER);
  }

  checkToken(): Observable<Token> {
    return this.httpClient.get<Token>(ApiConsts.AUTH.CHECK_TOKEN);
  }

  logout(): Observable<boolean> {
    return this.httpClient.post<any>(ApiConsts.AUTH.LOGOUT, {}).pipe(
      map(() => true)
    );
  }
}
